import { createContext } from 'react';
import { ResolutionsContextProps } from './Resolutions.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const ResolutionsContext = createContext<ResolutionsContextProps>(undefined);

export default ResolutionsContext;
